import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import ProjectCard from './ProjectCard';
import Particle from '../Particle';

import DefaultProject from '../../assets/Projects/DefaultProject.jpg';
import Game2048 from '../../assets/Projects/Game2048.png';
import Superchat from '../../assets/Projects/Superchat.png';
import VisitedPlaces from '../../assets/Projects/VisitedPlaces.png';
import BlogTemplate from '../../assets/Projects/BlogTemplate.png';
import PortfolioTemplate from '../../assets/Projects/PortfolioTemplate.png';

function Projects(props) {
	let english = {
		"heading1": "My Recent",
		"heading2": "Projects",
		"heading3": "Here are a few projects I have worked on recently.",
		"project6_title": "2048 Game",
		"project6_desc": "2048 is a logical game that was intended to be an improved version of the iOS game Threes which was released a month earlier. The objective of the game is to slide numbered tiles on a grid to combine them to create a tile with the number 2048",
		"project5_title": "Basic Chat Application",
		"project5_desc": "Basic application with chat made in React.js. For storing data (like user messages) I used Firebase. Also I implemented Google Authorization based on Firebase Auth.You can use it for chatting with other people if you want!",
		"project4_title": "Visited Places",
		"project4_desc": "This one is an application I made with my friend as a university project. The task was to create a mobile app and web admin panel that have a common database in Firebase. I was responsible for web application.I made it using Node.js for backend and Pug for frontend.",
		"project3_title": "Basic Library API",
		"project3_desc": "As an exercise for the backend, I decided to create API using Node.js and MongoDB for storing data. It has basic schemas like User, Book or Reservations. There is a lot of endpoints you can use for any library app. Everything is secured with JWT tokens.",
		"project2_title": "Blog Template",
		"project2_desc": "Basic page for some kind of a blog. It contains some cool looking features like for example image carousel. All styles was written without using bootstrap.",
		"project1_title": "Portfolio Template",
		"project1_desc": "Basic portfolio template made in HTML, CSS, Bootstrap and some other cool features - more in project files. It contains a lot of different sections where I tried to use various styles and animations.",
	};

	let polish = {
		"heading1": "Moje Ostatnie",
		"heading2": "Projekty",
		"heading3": "Kilka projektów, nad którymi ostatnio pracowałem.",
		"project6_title": "Gra 2048",
		"project6_desc": "2048 to gra logiczna, która została stworzona jako ulepszona wersja gry na iOS - Threes!, która wyszła miesiąc wcześniej. Celem gry jest takie przesuwanie i łączenie pojawiających się na planszy klocków, aby utworzyć klocek z liczbą 2048.",
		"project5_title": "Aplikacja z czatem",
		"project5_desc": "Prosta aplikacja z czatem wykonana w React.js. Do przechowywania danych (np. wiadomości użytkowników) użyłem Firebase. Zaimplementowałem również autoryzację przez Google, która jest dostępna w pakiecie Firebase Auth. Aplikacji można używać do rozmowy z innymi ludźmi.",
		"project4_title": "Odwiedzone Miejsca",
		"project4_desc": "Jest to aplikacja, która była częścią projektu robionego z moim znajomym na studiach. Naszym zadaniem było stworzenie aplikacji mobilnej oraz webowego panelu administracyjnego, które mają wspólną bazę danych w Firebase. Ja byłem odpowiedzialny za stworzenie aplikacji webowej. Stworzyłem ją używając Node.js dla backendu oraz Pug dla frontendu.",
		"project3_title": "Proste API dla biblioteki",
		"project3_desc": "Jako ćwiczenie dla backendu, postanowiłem stworzyć API do obsługi biblioteki używając Node.js oraz MongoDB do przechowywania danych. Posiada podstawowe struktury danych takie jak Użytkownik, Książka czy Rezerwacje. Znajduje się w niej sporo różnych endpointów, które możnaby użyć w aplikacji bibliotecznej. Wszystko zostało zabezpieczone tokenem JWT.",
		"project2_title": "Szablon na Blog",
		"project2_desc": "Prosty szablon strony pod jakiś blog internetowy. Zawiera kilka ciekawie wyglądających elementów jak np. karuzela obrazków. Wszystkie style zostały napisane bez użycia Bootstrapa.",
		"project1_title": "Szablon na Portfolio",
		"project1_desc": "Ciekawy szablon pod portfolio stworzony w HTML, CSS, Bootstrapie i kilku innych ciekawych technologiach - więcej w plikach projektu. Zawiera wiele różnych sekcji, w których starałem się używać różnych styli i animacji.",
	};

	let language = '';
	if (props.language === 'english') {
		language = english;
	} else {
		language = polish;
	}

	return (
		<Container fluid className='project-section'>
			<Particle />
			<Container>
				<h1 className='project-heading'>
					{language.heading1} <strong className='color2'>{language.heading2} </strong>
				</h1>
				<p style={{ color: 'white' }}>
					{language.heading3}
				</p>
				<Row style={{ justifyContent: 'center', paddingBottom: '10px' }}>
					<Col md={4} className='project-card'>
						<ProjectCard
							imgPath={Game2048}
							title={language.project6_title}
							description={language.project6_desc}
							linkgit='https://bitbucket.org/rezuss/2048game'
							linklive='https://confident-colden-eef7b0.netlify.app'
						/>
					</Col>
					<Col md={4} className='project-card'>
						<ProjectCard
							imgPath={Superchat}
							title={language.project5_title}
							description={language.project5_desc}
							linkgit='https://bitbucket.org/rezuss/superchat'
						/>
					</Col>
					<Col md={4} className='project-card'>
						<ProjectCard
							imgPath={VisitedPlaces}
							title={language.project4_title}
							description={language.project4_desc}
							linkgit='https://bitbucket.org/rezuss/mobileprojectutp'
						/>
					</Col>
					<Col md={4} className='project-card'>
						<ProjectCard
							imgPath={DefaultProject}
							title={language.project3_title}
							description={language.project3_desc}
							linkgit='https://bitbucket.org/rezuss/librarynodeapi'
						/>
					</Col>
					<Col md={4} className='project-card'>
						<ProjectCard
							imgPath={BlogTemplate}
							title={language.project2_title}
							description={language.project2_desc}
							linkgit='https://github.com/robertburitta/BlogTemplate'
							linklive='https://boring-yonath-59b56f.netlify.app'
						/>
					</Col>
					<Col md={4} className='project-card'>
						<ProjectCard
							imgPath={PortfolioTemplate}
							title={language.project1_title}
							description={language.project1_desc}
							linkgit='https://github.com/robertburitta/PortfolioTemplate'
							linklive='https://priceless-bohr-58e614.netlify.app'
						/>
					</Col>
				</Row>
			</Container>
		</Container>
	);
}

export default Projects;
